export const mapMarket = {
  "en-ca": "en-US",
  "fr-ca": "en-US",
  "en-nz": "en-AU",
  "fr-be": "nl-NL",
  "nl-be": "nl-NL",
};
